import { GeneralSetting } from '@apis/index'
import { Button, Row } from '@components'
import Fields from '@components/fields'
import {
  StyleFormFieldWrapper,
  StyleFormRowWrapper,
} from '@components/fields/style'
import { StyleColumn } from '@components/styles'
import {} from '@pages/admin/auth/style'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const AdminSupportAgentForm = ({ supportAgent }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState({
    name: '',
    phoneNo: '',
    messageNo: '',
    whatsAppNo: '',
    avatar: '',
  })
  const submitHandler = async (values: any) => {
    setLoading(true)
    const value = {
      whatsAppNo: values?.whatsAppNo,
      phoneNo: values?.phoneNo,
      name: values?.name,
      messageNo: values?.messageNo,
    }
    const payload: any = {
      key: 'supportAgent',
      title: 'Office Details',
      value: JSON.stringify(value),
      file: {
        extension: values?.avatar?.extension,
        base64: values?.avatar?.base64,
      },
    }

    if (!!supportAgent?.id) {
      await GeneralSetting.update('supportAgent', payload, supportAgent?.id)
        .then(() => {
          navigate('/admin/help-support')
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
    } else {
      await GeneralSetting.create('supportAgent', payload)
        .then(() => {
          navigate('/admin/help-support')
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
    }
  }
  useEffect(() => {
    if (!!supportAgent?.id) {
      const agentValue = !!supportAgent?.value
        ? JSON.parse(supportAgent?.value)
        : null
      setInitialValues({
        name: agentValue?.name,
        phoneNo: agentValue?.phoneNo,
        messageNo: agentValue?.messageNo,
        whatsAppNo: agentValue?.whatsAppNo,
        avatar: supportAgent?.file,
      })
    } else {
      setInitialValues({
        name: '',
        phoneNo: '',
        messageNo: '',
        whatsAppNo: '',
        avatar: '',
      })
    }
  }, [supportAgent?.id])
  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={submitHandler}
      >
        {({ values }) => (
          <Form>
            <StyleColumn>
              <StyleFormRowWrapper>
                <StyleFormFieldWrapper width={68}>
                  <StyleFormRowWrapper>
                    <StyleFormFieldWrapper width={48}>
                      <Fields.Input
                        name="name"
                        label="Full Name"
                        placeholder="Full Name"
                      />
                    </StyleFormFieldWrapper>
                    <StyleFormFieldWrapper width={48}>
                      <Fields.PhoneInput
                        name="phoneNo"
                        label="Phone No"
                        placeholder="Phone No"
                      />
                    </StyleFormFieldWrapper>
                    <StyleFormFieldWrapper width={48}>
                      <Fields.PhoneInput
                        name="messageNo"
                        label="Message No"
                        placeholder="Message No"
                      />
                    </StyleFormFieldWrapper>
                    <StyleFormFieldWrapper width={48}>
                      <Fields.PhoneInput
                        name="whatsAppNo"
                        label="WhatsApp No"
                        placeholder="WhatsApp No"
                      />
                    </StyleFormFieldWrapper>
                  </StyleFormRowWrapper>
                </StyleFormFieldWrapper>
                <StyleFormFieldWrapper width={28}>
                  <Fields.Upload
                    name="avatar"
                    label="Agent Avatar"
                    varient="avatar"
                    value={
                      values?.avatar
                        ? `${process.env.BUCKET_URL}/${values?.avatar}`
                        : null
                    }
                  />
                </StyleFormFieldWrapper>
              </StyleFormRowWrapper>

              <Row styleRow={{ marginLeft: 'auto' }}>
                <Button
                  type="submit"
                  title="Save"
                  height={40}
                  loading={loading}
                />
              </Row>
            </StyleColumn>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default AdminSupportAgentForm
